import * as React from "react";
import "../Styles/style.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { awsImageURL, baseUrl } from "../../api/ipconfig";
import UserDetails from "../ads/userDetails";
import MyadsNavigation from "../ads/myads-navigation";
import { Grid, Paper } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import "react-datepicker/dist/react-datepicker.css";
import { Modal, Box } from "@mui/material";
import Lottie from "lottie-react";
import InReview from "../../images/doc-in-review.json";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const successModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "10%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

export default function UserDashboard() {
  const history = useHistory();
  const token = localStorage.getItem("token");

  const [posts, setPosts] = useState([]);
  const [data, setData] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [user, setUser] = useState(null);
  const [referalCount, setReferalCount] = useState(0);
  const [subsDetails, setSubsDetails] = useState({});
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [postError, setPostError] = useState("");
  const [postErrOpen, setPostErrorOpen] = React.useState(false);

  const handleBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
  };

  const handlePostClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
  };

  const fetchUserPosts = async () => {
    try {
      const response = await axios.get(`${baseUrl}/getUser`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUser(response?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getsubscriptiondatails = async () => {
    try {
      const response = await axios.get(`${baseUrl}/getsubscriptiondatails`, {
        params: {
          user_id: user?.id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSubsDetails(response?.data?.details);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchRferalCount = async () => {
    try {
      const response = await axios.get(`${baseUrl}/userraferalcount`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setReferalCount(response?.data?.raferalcount);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchUserHistory = async () => {
    try {
      const response = await axios.get(`${baseUrl}/userprofilehistory`, {
        params: {
          userId: user?.id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setData(response?.data?.data);
      setPosts(response?.data?.post);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchUserSubscription = async () => {
    try {
      const response = await axios.get(`${baseUrl}/checkpackage`, {
        params: {
          user_id: user?.id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSubscriptionData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchUserPosts();
    fetchRferalCount();
    getsubscriptiondatails();
  }, []);
  useEffect(() => {
    if (user?.id) {
      fetchUserHistory();
      fetchUserSubscription();
    }
  }, [user]);

  const openPost = (postId) => {
    history.push(`/vehicle-details/${postId}`);
  };

  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  return (
    <>
      <Snackbar
        open={postErrOpen}
        autoHideDuration={6000}
        onClose={handleBarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handlePostClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {postError}
        </Alert>
      </Snackbar>

      <Modal
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        disableAutoFocus={true}
      >
        <Box className="text-center successModal" sx={successModal}>
          <Lottie
            style={{ height: 250 }}
            animationData={InReview}
            loop={false}
          />
          <h3 className="fw-700">Verification In Process</h3>
          <p>Redirecting... </p>
        </Box>
      </Modal>

      <div className="MyAds_main">
        <UserDetails />
        <div className="container-md MyAds_body">
          <div className="row pb-5">
            <div className="col-lg-2  p-0">
              <MyadsNavigation />
            </div>
            <div className="col-lg-10 ">
              <div className="MyAdsArea_main position-relative">
                <Paper
                  className="p-3"
                  sx={{ width: "100%", overflow: "hidden" }}
                >
                  <div className="d-flex justify-content-end py-2">
                    <Link
                      to={"ad-category"}
                      className="bgSecondary border-0 py-2 px-3 text-white rounded-2"
                    >
                      Post Your Ad
                    </Link>
                  </div>
                  <div>
                    <p className="">Referal Count:{referalCount}</p>
                  </div>
                  <div className="container mt-3 pb-2">
                    <div className="row">
                      <div
                        className="col-lg  border2primary m-2   p-4 d-flex  align-items-start justify-content-between flex-column"
                        style={{ borderRadius: "20px" }}
                      >
                        <h4 className="text-start  color-black fw-600 w-40">
                          <span className="fw-700 fs-5 color-secondary">
                            Total Inspections
                          </span>

                          <br />
                          <span className="text-black">
                            {data?.totalquantity}
                          </span>
                        </h4>
                      </div>
                      <div
                        className="col-lg  border2primary m-2   p-4 d-flex  align-items-start justify-content-between flex-column"
                        style={{ borderRadius: "20px" }}
                      >
                        <h4 className="text-start pb-2 color-black fw-600 w-40">
                          <span className="fw-700 fs-5 color-secondary">
                            Used Inspections
                          </span>
                          <br />
                          <span className="text-black">
                            {data?.usedquantity}
                          </span>
                        </h4>
                      </div>
                      <div
                        className="col-lg  border2primary m-2   p-4 d-flex  align-items-start justify-content-between flex-column"
                        style={{ borderRadius: "20px" }}
                      >
                        <h4 className="text-start pb-2 color-black fw-600 w-40">
                          <span className="fw-700 fs-5 color-secondary">
                            Remaining Inspections
                          </span>

                          <br />
                          <span className="text-black">
                            {data?.remainingquantity}
                          </span>
                        </h4>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg  border2primary m-2   p-4 d-flex  align-items-start justify-content-between flex-column"
                        style={{ borderRadius: "20px" }}
                      >
                        <h4 className="text-start  color-black fw-600 w-40">
                          <span className="fw-700 fs-5 color-secondary">
                            Remaining Featured Ads
                          </span>

                          <br />
                          <span className="text-black">
                            {subsDetails?.remaining_Featured_ad}
                          </span>
                        </h4>
                      </div>
                      <div
                        className="col-lg  border2primary m-2   p-4 d-flex  align-items-start justify-content-between flex-column"
                        style={{ borderRadius: "20px" }}
                      >
                        <h4 className="text-start pb-2 color-black fw-600 w-40">
                          <span className="fw-700 fs-5 color-secondary">
                            Remaining Boosts
                          </span>
                          <br />
                          <span className="text-black">
                            {subsDetails?.purchaseboost_remaining}
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="container pb-3">
                    {subscriptionData?.map((data) => {
                      <div className="row" key={data?.assignfeaturepackage_id}>
                        <div
                          className="col-lg  border2primary m-2   p-4 d-flex  align-items-start justify-content-between flex-column"
                          style={{ borderRadius: "20px" }}
                        >
                          <h4 className="text-start  color-black fw-600 w-40">
                            <span className="fw-700 fs-5 color-secondary">
                              Total Feature Ads
                            </span>

                            <br />
                            <span className="text-black">
                              {data?.featurepackage_adsqty}
                            </span>
                          </h4>
                        </div>
                        <div
                          className="col-lg  border2primary m-2   p-4 d-flex  align-items-start justify-content-between flex-column"
                          style={{ borderRadius: "20px" }}
                        >
                          <h4 className="text-start pb-2 color-black fw-600 w-40">
                            <span className="fw-700 fs-5 color-secondary">
                              Used Feature Ads
                            </span>
                            <br />
                            <span className="text-black">
                              {data?.usedquantity}
                            </span>
                          </h4>
                        </div>
                        <div
                          className="col-lg  border2primary m-2   p-4 d-flex  align-items-start justify-content-between flex-column"
                          style={{ borderRadius: "20px" }}
                        >
                          <h4 className="text-start pb-2 color-black fw-600 w-40">
                            <span className="fw-700 fs-5 color-secondary">
                              Remaining Feature Ads
                            </span>

                            <br />
                            <span className="text-black">
                              {data?.remainingquantity}
                            </span>
                          </h4>
                        </div>
                      </div>;
                    })}
                  </div>
                  <div className="container">
                    <Grid container spacing={2}>
                      {posts &&
                        posts.map((item) => (
                          <Grid
                            lg={3}
                            md={4}
                            sm={6}
                            className=" col-6 mb-3 p-2"
                            key={item?.postId}
                            onClick={() => openPost(item?.postId)}
                          >
                            <div className="adPost">
                              <div className="position-relative ">
                                <img
                                  src={`${awsImageURL}/posts/${item?.post_token}/${item?.cover}`}
                                  alt={`${item?.makeName} ${item?.modelName} ${item?.yearName}`}
                                  className="p-2"
                                  onError={(e) => {
                                    e.target.src =
                                      "https://gallery.famewheels.com/appgallery/no-image.png";
                                  }}
                                />
                                <div className="d-flex align-items-center justify-content-between position-absolute top-0 w-100 ">
                                  <div className="m-0 px-2 py-1 fw-500 featured-badge text-center">
                                    Featured
                                  </div>
                                </div>
                              </div>

                              <div className=" pb-2 px-2 ">
                                <div className=" bg-white p-2 rounded-2  ">
                                  <h5 className="fw-600 ad-Title color-black text-capitalize mb-1">
                                    {item?.makeName} {item?.modelName}{" "}
                                    {item?.yearName}
                                  </h5>
                                  <h4 className="fw-600 adPrice mb-1">
                                    <span>
                                      PKR {formatPrice(item?.price || 0)}
                                    </span>
                                  </h4>
                                  <p className="adlocation m-0 fw-500">
                                    <i className="fa-solid fa-location-dot me-2 color-secondary"></i>
                                    {item?.cityName}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Grid>
                        ))}
                    </Grid>
                  </div>
                </Paper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
